import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "../Shared";
import { useAuth, ROLE_HOME } from "../../context/AuthContext";

const LINKS = [
  { to: "/services", label: "Services" },
  { to: "/for-families", label: "For Families & NRIs" },
  { to: "/for-parents", label: "For Parents" },
  { to: "/plans", label: "Plans" },
  { to: "/trust", label: "Safety & Trust" },
  { to: "/about", label: "About" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-50 border-b border-stone-200/80 bg-sand/90 backdrop-blur-md">
      <div className="p1-container flex h-16 items-center justify-between">
        <Link to="/" aria-label="ParentOne home"><Logo /></Link>
        <nav className="hidden items-center gap-6 lg:flex" data-testid="main-nav">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to}
              className={({ isActive }) => `text-sm font-medium transition-colors hover:text-emerald-900 ${isActive ? "text-emerald-900" : "text-stone-600"}`}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <a href="tel:+918690545601" className="inline-flex items-center gap-1.5 text-sm font-semibold text-stone-600 hover:text-emerald-900" data-testid="nav-call-advisor">
            <Phone className="h-4 w-4" /> Talk to a Care Advisor
          </a>
          {user ? (
            <button onClick={() => navigate(ROLE_HOME[user.role] || "/app/family")} className="p1-btn-outline !py-2" data-testid="nav-dashboard-btn">My Dashboard</button>
          ) : (
            <Link to="/login" className="p1-btn-outline !py-2" data-testid="nav-login-btn">Login</Link>
          )}
          <Link to="/onboarding" className="p1-btn-primary !py-2" data-testid="nav-book-assessment-btn">Book Free Assessment</Link>
        </div>
        <button className="lg:hidden" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-stone-200 bg-sand px-4 py-4 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm font-medium text-stone-700">{l.label}</Link>
            ))}
            <div className="mt-2 flex gap-2">
              {user ? (
                <button onClick={() => { setOpen(false); navigate(ROLE_HOME[user.role] || "/app/family"); }} className="p1-btn-outline flex-1 !py-2" data-testid="nav-mobile-dashboard-btn">Dashboard</button>
              ) : (
                <Link to="/login" onClick={() => setOpen(false)} className="p1-btn-outline flex-1 !py-2 text-center">Login</Link>
              )}
              <Link to="/onboarding" onClick={() => setOpen(false)} className="p1-btn-primary flex-1 !py-2 text-center" data-testid="nav-mobile-assessment-btn">Book Assessment</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
